// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
export let base_url: string = 'https://api-bx30.aba.com';
export let chat_base_url: string = 'wss://api-bx30.aba.com/cable';
export const environment = {
  production: true,
  base_url: 'https://api-bx30.aba.com',
  chat_base_url: 'wss://api-bx30.aba.com/cable',
  front_end_url: 'https://bx30.aba.com'
};
